export default __webpack_public_path__ + "static/media/siam_n.d48f9412.jpg";